import { createClient } from "@supabase/supabase-js";

// Create React App reads env vars via process.env, and ONLY variables
// prefixed with REACT_APP_ are exposed to the browser bundle — anything
// else (e.g. plain SUPABASE_URL) will be undefined here, by design.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    "Missing Supabase env vars. Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to your .env file, then restart the dev server (CRA only reads .env at startup, not on hot reload)."
  );
}

// This is the ANON key only — safe to ship in the browser bundle. Never put
// the service_role key anywhere under src/; that one only belongs in
// netlify/functions (see supabaseAdminClient.js there).
export const supabase = createClient(supabaseUrl, supabaseAnonKey);